module.exports = __webpack_public_path__ + "img/sport_news.f76415a3.png";